import { render } from "./quotation.vue?vue&type=template&id=091965a4&scoped=true"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"

import "./quotation.vue?vue&type=style&index=0&id=091965a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091965a4"]])

export default __exports__